<template>
  <card-panel :id="recommendedJobsContainerIdState"
              :paddinglessContent="!!amountOfRecommendedJobs"
              class="recommended-jobs-container">
    <span v-translate slot="header-name" class="header">recommended jobs</span>
    <card-panel-items-amount-counter
      slot="header-counter"
      :amount="amountOfRecommendedJobs"
      :isNeedReview="isSomePublishedRecommendedJobNeedReview">
    </card-panel-items-amount-counter>

    <div slot="content">
      <div v-if="recommendedJobsLoadingState || createApplicationLoadingState" class="loader"></div>

      <div v-else-if="amountOfRecommendedJobs">
        <recommended-jobs-card-list
          v-if="recommendedPublishedJobsListState.length"
          :items="recommendedPublishedJobsListState"
          :show-items-amount="showItemsAmount"
          :is-all-items-shown="!trim[types.published]"
          :clickable="true"
          :show-more-less="showMoreLess(recommendedPublishedJobsListState)"
          @on-item-click="clickHandleRecommendedJob"
          @on-show-more="setTrim(types.published, false)"
          @on-show-less="setTrim(types.published, true)">
        </recommended-jobs-card-list>

        <recommended-unpublished-jobs-card-list
          :jobs-list="recommendedUnpublishedJobsListState"
          :show-items-amount="showItemsAmount"
          :is-all-items-shown="!trim[types.unpublished]"
          :clickable="false"
          :show-more-less="showMoreLess(recommendedUnpublishedJobsListState)"
          @on-item-click="clickHandleRecommendedJob"
          @on-show-more="setTrim(types.unpublished, false)"
          @on-show-less="setTrim(types.unpublished, true)">
        </recommended-unpublished-jobs-card-list>
      </div>

      <recommended-jobs-not-enough-information
        v-else-if="!amountOfRecommendedJobs && !isQuestionnaireFilled"
        @click="redirectToQuestionnaire"
      ></recommended-jobs-not-enough-information>

      <recommended-jobs-not-found v-else></recommended-jobs-not-found>
    </div>
  </card-panel>
</template>

<script>

import CardPanel from 'top20common/components/card-panel/CardPanel';
import CardPanelItemsAmountCounter from 'top20common/components/card-panel/CardPanelItemsAmountCounter';
import CounterTag from 'top20common/components/text-blocks/CounterTag';
import InfoTextBlock from 'top20common/components/text-blocks/InfoTextBlock';
import formatter from 'top20common/distribution/services/formatter';
import {mapGetters} from 'vuex';

import {PUBLISHED, UNPUBLISHED} from '@/utils/constants/jobs';

import RecommendedJobsCardList from '../recommended-jobs/RecommendedJobsCardList';
import RecommendedUnpublishedJobsCardList from '../recommended-jobs/RecommendedUnpublishedJobsCardList';
import RecommendedJobsNotEnoughInformation from './RecommendedJobsNotEnoughInformation.vue';
import RecommendedJobsNotFound from './RecommendedJobsNotFound.vue';

export default {
  data() {
    return {
      showItemsAmount: 5,
      types: {
        published: PUBLISHED,
        unpublished: UNPUBLISHED
      },
      trim: {
        [PUBLISHED]: true,
        [UNPUBLISHED]: true
      }
    };
  },
  computed: {
    ...mapGetters([
      'featureSwitchesState',
      'userDetailsState',
      'recommendedJobsContainerIdState',
      'recommendedJobsLoadingState',
      'recommendedPublishedJobsListState',
      'recommendedUnpublishedJobsListState',
      'amountOfRecommendedJobs',
      'isSomePublishedRecommendedJobNeedReview',
      'isQuestionnaireFilled',
      'createApplicationLoadingState'
    ])
  },
  methods: {
    setTrim(type, value) {
      this.trim[type] = value;
    },
    showMoreLess(jobs) {
      return jobs.length > this.showItemsAmount;
    },
    clickHandleRecommendedJob(item) {
      if (item.need_review) {
        this.$store.dispatch('reviewRecommendedJobAction', item.id);
      }
      let jobSlug = formatter.slugify(item.title);
      this.$router.push(`/jobs/${item.job_code}/${jobSlug}`);
    },
    redirectToQuestionnaire() {
      this.$router.push({name: 'questionnaire'});
    }
  },
  components: {
    CardPanel,
    CardPanelItemsAmountCounter,
    RecommendedJobsCardList,
    RecommendedUnpublishedJobsCardList,
    RecommendedJobsNotEnoughInformation,
    RecommendedJobsNotFound,
    CounterTag,
    InfoTextBlock
  }
};
</script>

<style lang="scss" scoped>
.recommended-jobs-container {
  /deep/ .items-amount-counter {
    margin-left: 5px;
  }

  .inner p {
    margin-bottom: 5px;
  }

  .image {
    height: 197px;
    margin-top: 20px;
  }
}
</style>
